import React, { useEffect, useRef, useState} from 'react';
import { ContenedorParametros } from '../../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../../components/buttons/BotonProcesar';
import { BotonNuevo } from '../../../components/buttons/BotonNuevo';
import fotoDefault from './../../../../assets/images/productoDefault.jpg';
import { useModal } from '../../../../hooks/useModal';
import { useRepuestos } from '../../../../hooks/registros/useRepuestos';
import { classNameInput, enviarImagenMinio, notify } from '../../../../utils/utils';
import { Tabs } from '../../../components/forms/Tabs';
import { useSettings } from '../../../../hooks/gestionMantenimientos/useSettings';
import { useBloqueoPantalla } from '../../../../hooks/useBloqueoPantalla';
import ModalConfirmarEliminacion from './ModalConfirmarEliminacion';
import TablaRepuestos from './TablaRepuestos';
import ModalRegistroEdicion from './ModalRegistroEdicion';

export const Repuestos = () => {
    const idTablaRepuestos = "tabla-hookRepuestos.repuestos";
    const inputFoto = useRef();
    const [bloquearPantalla,desbloquearPantalla,ComponenteBloqueo] = useBloqueoPantalla()
    const [isOpenRepuestos, openModalRepuesto, closeModalRepuestos] = useModal()
    const [isOpenModalEliminar, openModalEliminar, closeModalEliminar] = useModal()
    const hookRepuestos = useRepuestos()
    const hookSettings = useSettings()
    const [textoAnulacion,setTextoAnulacion] = useState('')
    const [repuestoTipo,setRepuestoTipo] = useState(0)

    useEffect(() => {
        (async() => {
            bloquearPantalla()
            await hookRepuestos.obtenerTipoDuracion()
            await hookSettings.listarTipoMoneda()
            await hookRepuestos.listarTipoArticulos()
            await hookRepuestos.comboUnidadMedida()
            await hookRepuestos.comboTipoSistema()
            await funcionListarTabla()
            desbloquearPantalla()
        })()
    }, [])
    
    useEffect(() => {
        hookRepuestos.editarValorRepuesto('codigoInterno',hookRepuestos.codigoRepuestoActual)
    },[hookRepuestos.codigoRepuestoActual])

    useEffect(() => {
        funcionListarTabla()
    }, [repuestoTipo])


    const funcionListarTabla = async () => {
        await hookRepuestos.listarRepuestos(repuestoTipo)
    }

    const menusModalEnviado = () => {
        const Menu1 = () =>
            <>
                <div className='flex gap-4 p-2'>
                    <div className='flex flex-col gap-2'>
                        <span>Mínimo:</span>
                        <input 
                            type='number'
                            min={0}
                            value={hookRepuestos.repuesto.stockMinimo} 
                            onInput={e => {
                                hookRepuestos.editarValorRepuesto('stockMinimo',e.target.value)
                            }} 
                            className={classNameInput}
                        />
                    </div>
                    <div className='flex flex-col gap-2'>
                        <span>Máximo:</span>
                        <input type='number' min={0} value={hookRepuestos.repuesto.stockMaximo} onInput={e => hookRepuestos.editarValorRepuesto('stockMaximo',e.target.value)} className={classNameInput}/>
                    </div>
                </div>
            </>
        const Menu2 = () =>
            <>
                <div className='flex gap-4 p-2'>
                    <div className='flex flex-col gap-2'>
                        <span>Moneda:</span>
                        <select value={hookRepuestos.repuesto.codMoneda} onChange={e => hookRepuestos.editarValorRepuesto('codMoneda',e.target.value)} className={classNameInput}>
                            <option value={0}>--Seleccione--</option>
                            {
                                hookSettings.tipoMonedas.map((data,i) => <option key={i+1} value={data.codMoneda}>{data.nomMoneda}</option>)
                            }
                        </select>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <span>Compra:</span>
                        <input type='number' min={0} value={hookRepuestos.repuesto.precioCosto} onChange={e => hookRepuestos.editarValorRepuesto('precioCosto',e.target.value)} className={classNameInput}/>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <span>Venta:</span>
                        <input type='number' min={0} value={hookRepuestos.repuesto.precioVenta} onChange={e => hookRepuestos.editarValorRepuesto('precioVenta',e.target.value)} className={classNameInput}/>
                    </div>
                </div>
            </>
        const Menu3 = () => 
            <>
                <div className='flex gap-4 p-2'>
                    <div className='flex flex-col gap-2'>
                        <span>T.Duración:</span>
                        <select value={hookRepuestos.repuesto.codRepuestoDuracionTipo} onChange={e => hookRepuestos.editarValorRepuesto('codRepuestoDuracionTipo',e.target.value)} className={classNameInput}>
                            <option value={0}>--Seleccione--</option>
                            {
                                hookRepuestos.tipoDuracion.map((data,i) => <option key={i+1} value={data.codRepuestoDuracionTipo}>{data.nomRepuestoDuracionTipo}</option>)
                            }
                        </select>
                    </div>
                    <div className='flex flex-col gap-2'>
                        <span>Duración:</span>
                        <input type='number' min={0} value={hookRepuestos.repuesto.duracion} onChange={e => hookRepuestos.editarValorRepuesto('duracion',e.target.value)} className={classNameInput} />
                    </div>
                </div>
            </>

        return [
            {
                nombreMenu: 'Alerta de stock',
                contenidoMenu: Menu1()
            },
            {
                nombreMenu: 'Precio referencial',
                contenidoMenu: Menu2()
            },
            {
                nombreMenu: 'Durabilidad',
                contenidoMenu: Menu3()
            },
        ]
    }

    const modificarImagen = (e) => {
        const archivoImagen = e.target.files[0]
        const urlArchivoImagen = URL.createObjectURL(archivoImagen)
        hookRepuestos.editarValorRepuesto('urlImagen',urlArchivoImagen)
    }

    return (
        <>
            <ComponenteBloqueo></ComponenteBloqueo>

            <ContenedorParametros titulo='Productos y servicios' tablaId={idTablaRepuestos} >   
                <label className='lg:hidden'>Tipo:</label>
                <div>
                    <select value={repuestoTipo} onChange={(e) => setRepuestoTipo(e.target.value)} className={`${classNameInput} `}>
                        <option value={0}>-- Todos --</option>
                        {
                            hookRepuestos.listaArticulos.map((data,i) => 
                                (<option key={i+1} value={data.codRepuestoTipo}>{data.nomRepuestoTipo}</option>)
                            )
                        }
                    </select>
                </div>
                <BotonProcesar onClick={funcionListarTabla}></BotonProcesar>       
                <BotonNuevo 
                    onClick={() => {
                        openModalRepuesto()
                        hookRepuestos.setRepuesto(hookRepuestos.repuestoDefault)
                    }}
                >
                </BotonNuevo>
            </ContenedorParametros>

            <TablaRepuestos
                idTablaRepuestos = {idTablaRepuestos}
                repuestoTipo = {repuestoTipo}
                repuestos = {hookRepuestos.repuestos}
                setRepuesto = {hookRepuestos.setRepuesto}
                repuestoDefault = {hookRepuestos.repuestoDefault}
                openModalRepuesto = {openModalRepuesto}
                setTextoAnulacion = {setTextoAnulacion}
                openModalEliminar = {openModalEliminar}
            ></TablaRepuestos>

            
            <ModalRegistroEdicion
                hookRepuestos = {hookRepuestos}
                isOpenRepuestos = {isOpenRepuestos}
                closeModalRepuestos = {closeModalRepuestos}
                fotoDefault = {fotoDefault}
                inputFoto = {inputFoto}
                modificarImagen = {modificarImagen}
                Tabs = {Tabs}
                menusModalEnviado = {menusModalEnviado}
                funcionListarTabla = {funcionListarTabla}
            ></ModalRegistroEdicion>

            <ModalConfirmarEliminacion
                hookRepuestos = {hookRepuestos}
                isOpenModalEliminar = {isOpenModalEliminar}
                closeModalEliminar = {closeModalEliminar}
                textoAnulacion = {textoAnulacion}
                setTextoAnulacion = {setTextoAnulacion}
                funcionListarTabla = {funcionListarTabla}
            ></ModalConfirmarEliminacion>
        </>
    )
}